import type { AnnualFeeAccountView } from '@stm/contracts';
import { parseAmountInput } from './billing';

/** `all`, `none` (athletes on no team) or a team season id. */
export type AnnualFeeTeamFilter = string;

export const allTeams = 'all';
export const noTeam = 'none';

/** Like `parseAmountInput`, but a zero rate is allowed: a category that pays nothing. */
export function parseRateInput(text: string): string | null {
  if (/^0+(?:[.,]0{1,2})?$/.test(text.replace(/\s/g, ''))) return '0';
  return parseAmountInput(text);
}

export interface AnnualFeeTeamOption {
  teamSeasonId: string;
  teamName: string;
}

export function teamOptions(accounts: readonly AnnualFeeAccountView[]): AnnualFeeTeamOption[] {
  const teams = new Map<string, string>();
  for (const account of accounts) {
    for (const athlete of account.athletes) {
      if (athlete.team !== null) teams.set(athlete.team.teamSeasonId, athlete.team.teamName);
    }
  }
  return [...teams]
    .map(([teamSeasonId, teamName]) => ({ teamSeasonId, teamName }))
    .sort((left, right) => left.teamName.localeCompare(right.teamName));
}

/** A family account appears under every team one of its athletes is on. */
export function filterAnnualFeeAccounts(
  accounts: readonly AnnualFeeAccountView[],
  team: AnnualFeeTeamFilter,
  onlyOpen: boolean,
): AnnualFeeAccountView[] {
  return accounts.filter((account) => {
    if (onlyOpen && account.remainingMinor === '0') return false;
    if (team === allTeams) return true;
    if (team === noTeam) {
      return (
        account.athletes.length === 0 || account.athletes.some((athlete) => athlete.team === null)
      );
    }
    return account.athletes.some((athlete) => athlete.team?.teamSeasonId === team);
  });
}
